/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import React from "react"
import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form"

interface InputErrorProps {
  readonly error?: FieldError | Merge<FieldError, FieldErrorsImpl>
}

const InputError: React.FC<InputErrorProps> = ({ error }) => {
  let errorMessage: string | undefined

  if (error) {
    if (typeof error.message === "string" && error.message) {
      errorMessage = error.message
    } else if (error.root && typeof error.root.message === "string") {
      // upon submit, errors without a path are assigned to error.root;
      // this small hack seems like the best way of dealing with it
      errorMessage = error.root.message
    }
  }

  if (!errorMessage) {
    return null
  }

  return <div className="invalid-feedback">{errorMessage}</div>
}

export default InputError
